import React from 'react'
import styled from 'styled-components'

import Icon, { IIcon } from '../Icon'

const Wrapper = styled.div<{ inline?: boolean }>`
  display: ${({ inline }) => (inline ? 'inline-block' : 'block')};
`

export interface TChevronToggle extends IIcon {
  isToggled?: boolean
  inline?: boolean
  solid?: boolean
  toTheRight?: boolean
}

const ChevronToggle = (props: TChevronToggle): React.ReactElement => {
  const { isToggled = false, inline, solid, toTheRight, ...rest } = props

  return (
    <Wrapper inline={inline}>
      <Icon
        icon={`fa${solid ? 's' : 'r'} fa-chevron-${
          isToggled
            ? toTheRight
              ? 'down'
              : 'up'
            : toTheRight
            ? 'right'
            : 'down'
        }`}
        {...rest}
      />
    </Wrapper>
  )
}

export default ChevronToggle
